if (!customElements.get('accordion-grid')) {
  customElements.define('accordion-grid', class AccordionGrid extends HTMLElement {
    constructor() {
      super();
      this.boundCalculateCentering = this.calculateCentering.bind(this);
      this.boundScheduleCentering = () => this.scheduleCentering();
      this.resizeRaf = null;
      this.loadHandler = null;
      this.lastLayoutKey = '';
      this.lastImgMarginTop = '';
      this.lastContentMarginTop = '';
    }

    connectedCallback() {
      this.grid = this.querySelector('.accordion-grid');
      this.imgCol = this.querySelector('.accordion-grid__image');
      this.contentCol = this.querySelector('.accordion-grid__content-wrapper');
      if (!this.imgCol || !this.contentCol) return;
      this.scheduleInitialCentering();
      this.watchImageLoad();

      this.addEventListener('columns-ready', this.boundScheduleCentering);

      window.addEventListener('resize', this.boundScheduleCentering);
    }

    watchImageLoad() {
      const img = this.imgCol.querySelector('img');
      if (!img || img.complete) return;
      img.addEventListener('load', this.boundScheduleCentering);
      img.addEventListener('error', this.boundScheduleCentering);
    }

    watchFontsReady() {
      if (!document.fonts || !document.fonts.ready) return;
      document.fonts.ready.then(this.boundScheduleCentering);
    }

    scheduleInitialCentering() {
      const run = () => {
        this.loadHandler = null;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.scheduleCentering();
          });
        });
      };

      if (document.readyState === 'complete') {
        run();
        return;
      }

      if (this.loadHandler) return;
      this.loadHandler = run;
      window.addEventListener('load', this.loadHandler, { once: true });
    }

    scheduleCentering() {
      if (this.resizeRaf) return;
      this.resizeRaf = requestAnimationFrame(() => {
        this.resizeRaf = null;
        this.calculateCentering();
      });
    }

    calculateCentering() {
      if (window.innerWidth <= 768) {
        this.lastLayoutKey = '';
        if (this.lastImgMarginTop !== '0px') {
          this.imgCol.style.marginTop = '0px';
          this.lastImgMarginTop = '0px';
        }
        if (this.lastContentMarginTop !== '0px') {
          this.contentCol.style.marginTop = '0px';
          this.lastContentMarginTop = '0px';
        }
        return;
      }

      const imgH = this.imgCol.offsetHeight;
      const contentH = this.contentCol.offsetHeight;
      const key = `${imgH}:${contentH}`;
      if (key === this.lastLayoutKey) return;
      this.lastLayoutKey = key;

      let nextImgMarginTop = '0px';
      let nextContentMarginTop = '0px';

      if (imgH > contentH) {
        nextContentMarginTop = `${(imgH - contentH) / 2}px`;
      } else {
        nextImgMarginTop = `${(contentH - imgH) / 2}px`;
      }

      if (this.lastImgMarginTop !== nextImgMarginTop) {
        this.imgCol.style.marginTop = nextImgMarginTop;
        this.lastImgMarginTop = nextImgMarginTop;
      }

      if (this.lastContentMarginTop !== nextContentMarginTop) {
        this.contentCol.style.marginTop = nextContentMarginTop;
        this.lastContentMarginTop = nextContentMarginTop;
      }
      this.grid.classList.replace('align-center', 'align-start');
      this.grid.classList.add('align-self-center');
    }

    disconnectedCallback() {
      this.removeEventListener('columns-ready', this.boundScheduleCentering);
      window.removeEventListener('resize', this.boundScheduleCentering);
      const img = this.imgCol && this.imgCol.querySelector('img');
      if (img) {
        img.removeEventListener('load', this.boundScheduleCentering);
        img.removeEventListener('error', this.boundScheduleCentering);
      }
      if (this.resizeRaf) {
        cancelAnimationFrame(this.resizeRaf);
        this.resizeRaf = null;
      }
      if (this.loadHandler) {
        window.removeEventListener('load', this.loadHandler);
        this.loadHandler = null;
      }
    }
  });
};
